import { slices } from "@/constants/sliceNames";
import {
  requestInvitationsListStatus,
  requestDeleteInvitationStatus,
  requestSendInvitationStatus,
} from "@/store/effects/settings/invitations-effects";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  records_count: 0,
  loading: false,
  error: null,
};

const invitationSlice = createSlice({
  name: slices.invitations,
  initialState,
  extraReducers: {
    ...requestInvitationsListStatus,
    ...requestDeleteInvitationStatus,
    ...requestSendInvitationStatus,
  },
});

const { actions, reducer } = invitationSlice;

export { actions, initialState };

export default reducer;
